var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarToggleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 5h12.8c.884 0 1.6.696 1.6 1.556v10.888c0 .86-.716 1.556-1.6 1.556H5.6c-.884 0-1.6-.696-1.6-1.556V6.556C4 5.696 4.716 5 5.6 5zM9 5v14"
  })));
}
export default SvgSidebarToggleIcon;